const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaUsuario: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'LAUDO_CONTROLE_ITEM_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'LAUDO_CONTROLE_ITEM_USUARIO_SELECT_LISTADO':
            return { ...state,
				listaUsuario: action.payload.data
			};

        case 'LAUDO_CONTROLE_ITEM_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        default:
            return state;
    }
}
